import * as React from "react";
import { LoadingSpinner } from "../../components/ui/loading-spinner";
export const Loading = () => (React.createElement("div", { className: "flex flex-1 flex-col h-full w-full mx-auto justify-center items-center" },
    React.createElement(LoadingSpinner, null)));
//# sourceMappingURL=Loading.js.map